var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9121 23.9311C64.1471 23.1648 62.9059 23.1635 62.141 23.9278L41.23 44.7768L32.7473 35.5638C32.0143 34.7681 30.775 34.7165 29.9781 35.4494C29.1817 36.1824 29.1307 37.4222 29.8637 38.2186L39.7281 48.9315C40.0893 49.3241 40.5949 49.5522 41.128 49.5632C41.1423 49.5638 41.1561 49.5638 41.1698 49.5638C41.6879 49.5638 42.1863 49.3581 42.5534 48.9922L64.9082 26.7028C65.6751 25.9386 65.6765 24.6974 64.9121 23.9311Z",
    fill: "#0196AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0401 40.0401C65.9577 40.0401 65.0804 40.9174 65.0804 42C65.0804 54.1756 55.1756 64.0804 43 64.0804C30.8251 64.0804 20.9196 54.1756 20.9196 42C20.9196 29.8251 30.8251 19.9196 43 19.9196C44.0825 19.9196 44.9599 19.0423 44.9599 17.9599C44.9599 16.8773 44.0825 16 43 16C28.6634 16 17 27.6634 17 42C17 56.336 28.6634 68 43 68C57.336 68 69 56.336 69 42C69 40.9175 68.1227 40.0401 67.0401 40.0401Z",
    fill: "#0196AA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -69.2808,
    y1: -69.863,
    x2: 42.5,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0196AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0196AA",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.2057e143.svg";
export { ForwardRef as ReactComponent };